import React, { useMemo, useState, Component } from 'react';
const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    inquiryType: '',
    message: ''
  });
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  // Create the mailto link with encoded subject and body
  const mailtoLink = useMemo(() => {
    const subject = `New Inquiry from ${formData.name} - ${formData.inquiryType}`;
    const body = `
Name: ${formData.name}
Email: ${formData.email}
Inquiry Type: ${formData.inquiryType}
Message:
${formData.message}
---
Sent via Hanomi Health Contact Form
    `.trim();
    return `mailto:info@hanomihealth.com?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  }, [formData]);
  const isFormValid = formData.name && formData.email && formData.inquiryType && formData.message;
  return <form className="space-y-4 sm:space-y-6 font-light" data-id="element-37">
      <div data-id="element-38">
        <label htmlFor="name" className="block text-gray-300 mb-1.5 sm:mb-2 font-light text-sm sm:text-base" data-id="element-39">
          Name
        </label>
        <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} required className="w-full px-3 sm:px-4 py-1.5 sm:py-2 bg-white border border-gray-300 rounded-lg text-gray-700 focus:outline-none focus:ring-2 focus:ring-custom-blue font-light text-sm sm:text-base" data-id="element-40" />
      </div>
      <div data-id="element-41">
        <label htmlFor="email" className="block text-gray-300 mb-1.5 sm:mb-2 font-light text-sm sm:text-base" data-id="element-42">
          Email
        </label>
        <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} required className="w-full px-3 sm:px-4 py-1.5 sm:py-2 bg-white border border-gray-300 rounded-lg text-gray-700 focus:outline-none focus:ring-2 focus:ring-custom-blue font-light text-sm sm:text-base" data-id="element-43" />
      </div>
      <div data-id="element-44">
        <label htmlFor="inquiryType" className="block text-gray-300 mb-1.5 sm:mb-2 font-light text-sm sm:text-base" data-id="element-45">
          Reason for Inquiry
        </label>
        <select id="inquiryType" name="inquiryType" value={formData.inquiryType} onChange={handleChange} required className="w-full px-3 sm:px-4 py-1.5 sm:py-2 bg-white border border-gray-300 rounded-lg text-gray-700 focus:outline-none focus:ring-2 focus:ring-custom-blue font-light text-sm sm:text-base" data-id="element-46">
          <option value="" data-id="element-47">Select a reason</option>
          <option value="Interested in investing" data-id="element-48">
            Interested in investing
          </option>
          <option value="Interested in referring a company for sale" data-id="element-49">
            Interested in referring a company for sale
          </option>
          <option value="Interested in applying for a position" data-id="element-50">
            Interested in applying for a position
          </option>
          <option value="Other" data-id="element-51">Other</option>
        </select>
      </div>
      <div data-id="element-52">
        <label htmlFor="message" className="block text-gray-300 mb-1.5 sm:mb-2 font-light text-sm sm:text-base" data-id="element-53">
          Description
        </label>
        <textarea id="message" name="message" value={formData.message} onChange={handleChange} rows={4} required className="w-full px-3 sm:px-4 py-1.5 sm:py-2 bg-white border border-gray-300 rounded-lg text-gray-700 focus:outline-none focus:ring-2 focus:ring-custom-blue font-light text-sm sm:text-base" data-id="element-54"></textarea>
      </div>
      <div data-id="element-55">
        <a href={isFormValid ? mailtoLink : '#'} onClick={e => {
        if (!isFormValid) {
          e.preventDefault();
          alert('Please fill out all fields before submitting.');
        }
      }} className={`block w-full px-4 sm:px-6 py-2 sm:py-3 text-center bg-custom-blue text-white font-light rounded-lg transition-all transform hover:scale-105 text-sm sm:text-base ${!isFormValid ? 'opacity-50 cursor-not-allowed' : 'hover:bg-custom-blue/90'}`} data-id="element-56">
          Submit Inquiry
        </a>
      </div>
    </form>;
};
export default ContactForm;